(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dorenzi-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dorenzi-countdown')) {
  customElements.define('dorenzi-countdown', class extends HTMLElement {
    connectedCallback() {
      this.deadline = Date.parse(this.dataset.deadline);
      this.cells = ['days','hours','minutes','seconds'].map(unit => this.querySelector('[data-unit="' + unit + '"]'));
      if (!Number.isFinite(this.deadline)) return;
      this.update();
      if (this.deadline > Date.now()) this.interval = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    update() {
      const total = Math.max(0, Math.floor((this.deadline - Date.now()) / 1000));
      const values = [Math.floor(total / 86400), Math.floor(total / 3600) % 24, Math.floor(total / 60) % 60, total % 60];
      this.cells.forEach((cell, i) => { cell.textContent = String(values[i]).padStart(2, '0'); });
      if (this.deadline <= Date.now()) {
        clearInterval(this.interval);
        this.querySelector('.dorenzi-countdown__grid').hidden = true;
        this.querySelector('.dorenzi-countdown__ended').hidden = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
